module.exports = __webpack_public_path__ + "img/product-watch.948da44c.jpg";